import { locale } from 'svelte-i18n';
import { derived } from 'svelte/store';

// Fonction pour extraire le code de langue
function getLanguageCode(localeString: string | undefined | null) {
    if( localeString)
        return localeString.split('-')[0].toUpperCase();
    return 'EN';
}

// Store dérivé pour obtenir uniquement le code de langue
const languageCode = derived(locale, $locale => getLanguageCode($locale));

export { languageCode };